import React, { Fragment } from 'react'
import { createPortal } from 'react-dom'
import { Link } from 'react-router-dom'

import { Heading, HyperButton, LazyImage, ModalBody } from '@offerzen/pinata-shame'

import Modal from '../../../CandidateExperience/components/ModalRedux'
import styles from './styles'

const ReapplyModal = props =>
  createPortal(
    <Modal name="reapplyModal" onModalClose={() => props.trackReapplyModal('close modal')}>
      {() => (
        <Fragment>
          <div className={styles.header}>
            <LazyImage className={styles.image} loader={() => import('../../../assets/searching-unicorn.svg')} width={65} alt="" />

            <Heading>We are happy to see you again!</Heading>
          </div>

          <ModalBody className={styles.wrapper}>
            <p className={styles.paragraph}>
              Now that you’re ready to find a new job and your profile has been submitted for review, don’t forget to update your profile to
              showcase what you have been doing since you last applied to OfferZen. Our team will use this information to evaluate whether
              we have open positions that match your skills and expectations.
            </p>
            <HyperButton
              label="Update profile"
              onClick={() => props.trackReapplyModal('update profile')}
              href={`/candidate/${props.candidateId}`}
              as={Link}
            />
          </ModalBody>
        </Fragment>
      )}
    </Modal>,
    document.getElementById('react-modal'),
  )

export default ReapplyModal
